module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/progress_03-bed795ddc31e1523a174a1b36a0dd28a.png";